import React, { useState } from "react";
import SelectInput from "../SelectInput/SelectInput";


const ServiceSelect = ({ options, name }) => {
  const [option, setOption] = useState('');
  const ordered_options = new Map(options);

  const handleSelectChanged = (option) => setOption(option);

  return (
    <div className="appointment-form__section appointment-form__section_border_bottom">
      <div className="appointment-form__header appointment-form__header_indent-b_large">
        Услуга
      </div>
      <input className="hidden" name={name} value={option} type="hidden" />
      <SelectInput options={ordered_options} onSelectChanged={handleSelectChanged} />
    </div>
  );
};

export default ServiceSelect;
